<template>
  <section :class="{ 'content-grid-component': true }">
    <Padding :padding="configuration?.padding">
      <div :class="{ 'container mx-auto px-0': true }">
        <div
          :class="{
            'grid grid-cols-12 items-center gap-3': true,
          }"
        >
          <div
            v-for="component in contentGrid?.content?.sectionBuilder"
            :key="component._key"
            :class="gridColumClass"
          >
            <ContentGridTheme :theme="configuration">
              <component
                :is="getComponent(component._type)"
                :value="component"
              />
            </ContentGridTheme>
          </div>
        </div>
      </div>
    </Padding>
  </section>
</template>

<script setup lang="ts">
import Padding from '~/components/Atoms/Padding/Padding.vue';
import { getComponent } from '~/components/Mapper';
import type { PortableTextContentGrid } from '~/sanity/types';
import ContentGridTheme from '../Themes/ContentGridTheme.vue';
const props = defineProps<PortableTextContentGrid>();
if (!props.contentGrid) {
  throw new Error('ContentGrid component is missing content');
}
const { columnsPerRow } = toRefs(props.contentGrid);
const gridColumClass = computed(() => {
  return {
    [columnsClass[columnsPerRow.value]]: true,
  };
});
const columnsClass = {
  '2': 'w-full col-span-12 md:col-span-6',
  '3': 'w-full col-span-12 md:col-span-4',
  '4': 'w-full col-span-12 md:col-span-3',
};
</script>

<style lang="scss">
.content-grid-component {
  .image-atom {
    &.container {
      padding-left: 0 !important;
      padding-right: 0 !important;
    }
  }
}
</style>
